// queries/getContactMe.ts
import { ContactMe } from '../types';

const staticContactMe: ContactMe = {
  profilePicture: { url: "https://via.placeholder.com/200x200/4f46e5/ffffff?text=Gourav+B" },
  name: "Gourav",
  title: "Freelance Software & Web Developer",
  summary: "Results-driven Freelance Software & Web Developer with expertise in building scalable, high-performance web applications. Specializing in React, Next.js, and Full Stack solutions, I am available for new projects and freelance opportunities.",
  companyUniversity: "Linkfields Innovation",
  linkedinLink: "https://linkedin.com/in/bgourav2287",
  email: "njrgourav@gmail.com",
  phoneNumber: "+917606914711"
};

export async function getContactMe(): Promise<ContactMe> {
  // Simulate async behavior
  return new Promise((resolve) => {
    setTimeout(() => resolve(staticContactMe), 100);
  });
}
